import { t } from '@/lib/i18n';
import { useState } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { PageContainer } from '@ant-design/pro-components';
import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { AsyncBoundary } from '@/components/async-boundary';
import { requireCanManageUsers } from '@/features/auth/session/guards';
import { useLegalDocuments } from '@/features/legal/legal-api';
import { LegalDocumentForm } from '@/features/legal/document/form';
import { LegalDocumentTable } from '@/features/legal/document/table';
import { useDocumentTitle } from '@/hooks/use-document-title';

export const Route = createFileRoute('/_authenticated/system/legal')({
  beforeLoad: async ({ context, location }) => {
    await requireCanManageUsers(context.queryClient, location.href);
  },
  component: LegalDocumentsPage,
});

function LegalDocumentsPage() {
  useDocumentTitle(t('隐私与协议'));
  const documents = useLegalDocuments();
  const [createOpen, setCreateOpen] = useState(false);

  const createButton = (
    <Button
      key="create"
      type="primary"
      icon={<PlusOutlined />}
      onClick={() => setCreateOpen(true)}
    >
      {t('新建隐私与协议')}
    </Button>
  );

  return (
    <PageContainer header={{ title: t('隐私与协议') }}>
      <AsyncBoundary
        result={documents}
        skeletonRows={6}
        emptyText={t('还没有任何文书，先新建一篇')}
        emptyAction={createButton}
      >
        {(items) => (
          <LegalDocumentTable
            documents={items}
            loading={documents.isFetching}
            onReload={() => void documents.refetch()}
            toolBar={createButton}
          />
        )}
      </AsyncBoundary>
      {createOpen ? (
        <LegalDocumentForm onClose={() => setCreateOpen(false)} />
      ) : null}
    </PageContainer>
  );
}
